(function ($) {

    function initActiveScrollSelector() {
        if($(".timeline-change").length > 0){
            var minusHeight = $(".timeline-change").outerHeight() + $("header").outerHeight();
            $(window).on("scroll", function () {
                var scroll = $(window).scrollTop();

                var activeSelector = $('section');
                var nav = $('.timeline-change ul');

                activeSelector.each(function () {
                    var top = $(this).offset().top  - minusHeight  - 100,
                        bottom = top + $(this).outerHeight();
                    if (scroll >= top && scroll <= bottom) {
                        nav.find('li.active').siblings('li.active').removeClass('active');
                        nav.find('a[href="#' + $(this).attr("id") + '"]').parent("li").addClass("active");
                        nav.find('a[href="#' + $(this).attr("id") + '"]').parent("li.active").clone().appendTo(".mobile-nav");
                    }
                    else if (scroll >= bottom) {
                        nav.find("li.active").removeClass("active");
                    }
                });
            });
        }
    }

    $(document).ready(function () {
        if ($(".timeline-change").length > 0) {
            initActiveScrollSelector();
            setTimeout(function () {
                $(".timeline-change").css("opacity", "1");
            }, 500);
        }
    });


})(jQuery);

